var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholderWithoutServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 413.664,
    height: 396.028,
    viewBox: "0 0 413.664 396.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_801",
    "data-name": "Grupo 801",
    transform: "translate(-639 -391)",
    opacity: 0.799
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_803",
    "data-name": "Grupo 803",
    transform: "translate(639 391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_801-2",
    "data-name": "Grupo 801",
    transform: "translate(0 33.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_563",
    "data-name": "Caminho 563",
    d: "M105.82,432.249C64.1,465.93,37.9,514.568,37.9,568.651c0,51.34,23.617,97.761,61.7,131.15,17.509,1.78,37.483,2.419,53.37,1.177,12.594-.984,19.127-2.69,22.052-4.614-3.957,13.331-36.755,15.287-61.823,14.352.424.31.846.624,1.271.931H297.78a9.617,9.617,0,0,1-3.221-7.174h0a9.663,9.663,0,0,1,9.634-9.635h91.135c34.865-32.956,56.239-77.347,56.239-126.188,0-62.428-34.915-117.591-88.3-150.883H257.538a11.781,11.781,0,0,1,.287,2.585h0a11.93,11.93,0,0,1-11.9,11.9Z",
    transform: "translate(-37.902 -390.747)",
    fill: "#dbdbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_564",
    "data-name": "Caminho 564",
    d: "M545.382,853.457H451.913a6.034,6.034,0,0,0-6.016,6.016h0a6.033,6.033,0,0,0,6.016,6.015h93.469a6.033,6.033,0,0,0,6.015-6.015h0A6.034,6.034,0,0,0,545.382,853.457Z",
    transform: "translate(-183.049 -545.746)",
    fill: "#dbdbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_565",
    "data-name": "Caminho 565",
    d: "M391.881,919.206H254.6a5.97,5.97,0,0,0-5.952,5.954h0a5.969,5.969,0,0,0,5.952,5.953h137.28a5.97,5.97,0,0,0,5.952-5.953h0A5.971,5.971,0,0,0,391.881,919.206Z",
    transform: "translate(-112.877 -569.136)",
    fill: "#dbdbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1573",
    "data-name": "Ret\\xE2ngulo 1573",
    d: "M6.015,0H32.083A6.015,6.015,0,0,1,38.1,6.015v0a6.016,6.016,0,0,1-6.016,6.016H6.016A6.016,6.016,0,0,1,0,6.015v0A6.015,6.015,0,0,1,6.015,0Z",
    transform: "translate(375.157 307.959)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_566",
    "data-name": "Caminho 566",
    d: "M509.9,920.265H493.445a5.97,5.97,0,0,0-5.952,5.953h0a5.969,5.969,0,0,0,5.952,5.952H509.9a5.97,5.97,0,0,0,5.953-5.952h0A5.971,5.971,0,0,0,509.9,920.265Z",
    transform: "translate(-197.847 -569.513)",
    fill: "#dbdbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_567",
    "data-name": "Caminho 567",
    d: "M209.3,920.265H192.842a5.971,5.971,0,0,0-5.952,5.953h0a5.969,5.969,0,0,0,5.952,5.952H209.3a5.969,5.969,0,0,0,5.952-5.952h0A5.97,5.97,0,0,0,209.3,920.265Z",
    transform: "translate(-90.905 -569.513)",
    fill: "#dbdbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1574",
    "data-name": "Ret\\xE2ngulo 1574",
    d: "M5.953,0H261.138a5.952,5.952,0,0,1,5.952,5.952v0a5.952,5.952,0,0,1-5.952,5.952H5.953A5.953,5.953,0,0,1,0,5.953v0A5.953,5.953,0,0,1,5.953,0Z",
    transform: "translate(78.493 326.059)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_568",
    "data-name": "Caminho 568",
    d: "M249.407,409.932H60.929a5.97,5.97,0,0,0-5.952,5.953h0a5.97,5.97,0,0,0,5.952,5.953H249.407a5.97,5.97,0,0,0,5.952-5.953h0A5.97,5.97,0,0,0,249.407,409.932Z",
    transform: "translate(-43.977 -387.959)",
    fill: "#dbdbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_569",
    "data-name": "Caminho 569",
    d: "M413.164,379.428H224.686a5.971,5.971,0,0,0-5.953,5.954h0a5.97,5.97,0,0,0,5.953,5.953H413.164a5.97,5.97,0,0,0,5.953-5.953h0A5.971,5.971,0,0,0,413.164,379.428Z",
    transform: "translate(-102.234 -377.107)",
    fill: "#dbdbdb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_1575",
    "data-name": "Ret\\xE2ngulo 1575",
    d: "M5.953,0H32.145A5.953,5.953,0,0,1,38.1,5.953v0a5.952,5.952,0,0,1-5.952,5.952H5.952A5.952,5.952,0,0,1,0,5.953v0A5.953,5.953,0,0,1,5.953,0Z",
    transform: "translate(67.206)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_802",
    "data-name": "Grupo 802",
    transform: "translate(69.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_570",
    "data-name": "Caminho 570",
    d: "M267.506,556.664s17.344,12.7,24.314,16.572,7.125,4.028,8.363,3.252,21.836-18.429,23.54-24.005.928-7.123.928-7.123a95.989,95.989,0,0,1,5.886,9.447c1.547,3.253.153,13.164-1.238,16.417s-12.857,20.6-14.094,20.287-6.5-8.749-9.833-11.228-5.343-2.633-8.21-2.865-4.648,1.006-7.046,5.885-3.484,8.519-4.569,8.6-5.422-3.329-9.139-6.814-10.3-13.474-10.684-15.641S266.5,558.677,267.506,556.664Z",
    transform: "translate(-188.103 -402.766)",
    fill: "#bbcafc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_571",
    "data-name": "Caminho 571",
    d: "M308.256,595.1c-2.866-.232-4.648,1.006-7.046,5.884-.093.192-.186.381-.276.568a53.784,53.784,0,0,1,3.836,6.325c1.394,3.1-6.661,17.036-6.661,41.351s-1.547,119.25-1.236,133.188,3.715,21.681,5.885,25.088,6.814,3.408,6.814,3.408l9.91-10.842s-4.644-115.224-4.644-136.285.851-48.707-.078-51.34a10.667,10.667,0,0,1-.078-5.652s1.857-.852,2.322-1.937a22.049,22.049,0,0,1,2.89-3.348,22.565,22.565,0,0,0-3.427-3.545C313.135,595.492,311.123,595.336,308.256,595.1Z",
    transform: "translate(-199.197 -420.454)",
    fill: "#9c2543",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_572",
    "data-name": "Caminho 572",
    d: "M251.391,579.737a24.559,24.559,0,0,1,.235-5.439,13.282,13.282,0,0,0-4.421,3.425c-2.788,3.564-7.589,12.235-13.318,18.9s-6.66,5.575-5.576,6.969,8.519,2.479,8.519,2.479-11.151,7.588-11.462,9.757,5.886,17.344,6.5,20.442,19.048,61.949,19.048,61.949l15.488,1.084s-14.249-78.674-15.334-96.175S251.391,579.737,251.391,579.737Z",
    transform: "translate(-173.769 -413.062)",
    fill: "#7a809e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_573",
    "data-name": "Caminho 573",
    d: "M158.78,649.57c-1.278-3.151-2.2-6.2-2.477-5.575-.62,1.393-3.717.774-3.406,3.562s-4.338,83.783-5.268,95.244-4.955,31.9.311,40.887,40.576,21.681,40.576,21.681-6.816-13.938-6.506-25.089a42.263,42.263,0,0,1,4.647-18.583s-1.94-3.794-1.09-5.886a5.544,5.544,0,0,1,2.17-2.786l-12.284-23.214,1.911-16.123S169,674.658,166.214,666.295A114.633,114.633,0,0,0,158.78,649.57Z",
    transform: "translate(-145.282 -437.827)",
    fill: "#7d84a8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_574",
    "data-name": "Caminho 574",
    d: "M182.462,705.648l46.123.393s-18.427-58.85-19.048-61.949-6.814-18.276-6.5-20.443,11.462-9.756,11.462-9.756-7.434-1.085-8.519-2.479-.156-.309,5.576-6.969a90.7,90.7,0,0,0,6.116-8.144c-6.212,3.434-16.027,8.8-26.179,14.106-15.907,8.32-27.62,15.745-28.914,16.571.371.145,1.224,2.86,2.357,5.653a114.637,114.637,0,0,1,7.433,16.725c2.79,8.364,11.151,47.391,11.151,47.391Z",
    transform: "translate(-151.434 -420.89)",
    fill: "#8e95b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_575",
    "data-name": "Caminho 575",
    d: "M259.235,838.692a5.445,5.445,0,0,1-1.818.522s.742-.242,1.818-.522Zm2.52-1.645c2.4-2.091,1.6-6.009-1.549-6.041s-36.086,8.442-37.557,8.674-1.238-.387-.618-1.163,22.922-8.13,23.849-11.149a4.43,4.43,0,0,0-4.722-5.732c-3.407.155-26.33,6.816-26.33,6.816l-6.814-15.177a5.546,5.546,0,0,0-2.17,2.786c-.85,2.092,1.09,5.886,1.09,5.886a42.263,42.263,0,0,0-4.647,18.583c-.144,5.148,1.233,10.888,2.754,15.578,3.145,3.263,8.471,4.789,8.471,4.789s.85.386,2.709,1.393,8.751,3.484,11.151,3.407a23.162,23.162,0,0,0,9.217-2.788c2.089-1.393,6.426-5.653,9.369-8.441s2.246-3.406,2.246-3.406,11.18-3.251,15.017-4.747c.019-2.554.041-5.363.067-8.379a26.573,26.573,0,0,0-4.052.756A10.184,10.184,0,0,0,261.755,837.047Z",
    transform: "translate(-165.558 -498.079)",
    fill: "#d3a48c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_576",
    "data-name": "Caminho 576",
    d: "M280.238,829.3c5.831.385,12.076.693,13.773.383,3.409-.62,6.039-1.7,5.732-3.407s-16.571-55.6-19.05-57.613a6.6,6.6,0,0,0-2.705-.764l-18.455-.532c-3.335.054-5.7.136-5.7.136l-15.488-1.084-46.123-.393s-2.049-.111-2.205,1.435,1.4,5.364,1.4,5.364l-.05.424,12.284,23.214,6.814,15.176s22.922-6.66,26.33-6.815a4.43,4.43,0,0,1,4.722,5.732c-.927,3.019-23.231,10.376-23.849,11.149s-.854,1.394.618,1.163,34.411-8.7,37.557-8.674,3.949,3.95,1.549,6.041a10.191,10.191,0,0,1-2.52,1.646,26.571,26.571,0,0,1,4.052-.756l-.064,7.991Z",
    transform: "translate(-161.192 -481.27)",
    fill: "#c7d4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_577",
    "data-name": "Caminho 577",
    d: "M359.046,558.361c1.236,2.595.6,9.427-.419,13.737-1.062,7.667-7.731,39.421-10.365,54.752-2.561,14.915-2.484,75.4-2.479,78.69.019-.588.256-3.126,2.79-9,2.942-6.813,33.22-96.792,33.606-98.727a28.644,28.644,0,0,0,.465-3.951l-10.607-8.206,9.834-3.176s-.387-.852-2.093-3.716-7.2-11.926-8.516-12.7a43.3,43.3,0,0,1-8.44-7.434c-3.25-3.717-5.432-3.26-5.432-3.26C358.045,556.461,358.639,557.511,359.046,558.361Z",
    transform: "translate(-216.611 -406.322)",
    fill: "#7a809e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_578",
    "data-name": "Caminho 578",
    d: "M430.38,589.984c-2.168-1.548-59.118-18-59.118-18,1.316.774,6.815,9.833,8.516,12.7s2.093,3.716,2.093,3.716l-9.834,3.176,10.607,8.206a28.644,28.644,0,0,1-.464,3.951c-.386,1.935-30.664,91.914-33.606,98.727a49.124,49.124,0,0,0-2.238,6.107l-.551,2.892,2.368,22.512c3.722,11.924,6.874,22.536,7.01,23.277.2,1.115-.857,1.966-2.569,2.592l11.5,40.77c21.866.273,44.23-2.271,68.135-13.547s-10.523-56.146-12.382-76.9,7.744-107.79,7.744-107.79S432.55,591.534,430.38,589.984Z",
    transform: "translate(-216.612 -412.237)",
    fill: "#8e95b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_579",
    "data-name": "Caminho 579",
    d: "M284.713,605.136c-1.084.078-5.422-3.329-9.136-6.814s-10.493-14.558-10.687-15.642-2.371,6.064-1.286,23.565,16.3,96,16.3,96,2.367-.083,5.7-.136c.3-24.093.572-47.031.572-57.32,0-24.315,8.056-38.253,6.661-41.351a53.769,53.769,0,0,0-3.836-6.325C286.8,601.7,285.755,605.063,284.713,605.136Z",
    transform: "translate(-187.269 -416.005)",
    fill: "#dce3f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_580",
    "data-name": "Caminho 580",
    d: "M324.419,607.566c.929,2.633.078,30.278.078,51.34,0,6.857.493,23.7,1.155,43.294a6.58,6.58,0,0,1,2.705.764c1.4,1.139,7.2,18.843,12.04,34.336l-2.368-22.512c-.005-3.285,2.7-63.742,5.3-78.866s6.479-46.909,7.541-54.577a17.329,17.329,0,0,1-.819,2.679c-1.394,3.253-12.857,20.6-14.094,20.287-.859-.215-3.659-4.347-6.406-7.681a21.939,21.939,0,0,0-2.89,3.346c-.465,1.085-2.322,1.937-2.322,1.937A10.668,10.668,0,0,0,324.419,607.566Z",
    transform: "translate(-208.857 -415.569)",
    fill: "#dce3f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_581",
    "data-name": "Caminho 581",
    d: "M191.883,768.865c8.577.563,25.354,1.568,36.015,1.568,7.667,0,20.845.319,31.589.633,10.023.291,17.932.579,17.28.6-.265.008.366,2.238,1.554,5.812,4.831,14.55,18.853,51.391,18.853,51.391,1.712-.628,2.77-1.477,2.569-2.592-.136-.741-3.288-11.353-7.01-23.277-4.84-15.493-10.64-33.2-12.04-34.336a6.581,6.581,0,0,0-2.705-.764l-18.455-.532c-3.335.054-5.7.136-5.7.136l-15.488-1.084-46.123-.393s-2.049-.111-2.205,1.435a4.7,4.7,0,0,0,.11,1.284C190.663,768.785,191.251,768.823,191.883,768.865Z",
    transform: "translate(-161.192 -481.27)",
    fill: "#a0b1e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_582",
    "data-name": "Caminho 582",
    d: "M333.56,399.3s5,18.574,5,26.43-.358,18.215.712,30-5.428,33.459-6.426,41.43-3.587,18.019-11.074,20.358-38.277-3.777-56.788-17.143-14.642-26.431-14.642-26.431-11.072-1.429-14.644-16.428-10.357-27.5.356-26.073,16.788,15.358,17.859,21.43,1.43,8.929,1.43,8.929l8.929.714s-6.429-16.786,0-27.144,18.57-13.215,16.428-18.215-9.286-6.429-6.43-12.858,23.932-8.215,37.148-7.857A100.534,100.534,0,0,1,333.56,399.3Z",
    transform: "translate(-175.518 -349.772)",
    fill: "#d3a48c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_583",
    "data-name": "Caminho 583",
    d: "M262.144,413.293a17.1,17.1,0,0,1,1.7-3.669c6.43-10.358,18.57-13.215,16.428-18.215s-9.286-6.429-6.43-12.859,23.932-8.215,37.148-7.857a100.536,100.536,0,0,1,22.143,2.857s5,18.574,5,26.43c0,0,1.787-18.929,2.142-25s3.216-23.214-1.43-29.286-30.715-23.93-57.144-21.429-43.217,18.75-46.966,25.178,5.714-1.786,7.32-2.677-10.894,15-12.5,26.607c-1.142,8.258-.3,21.938,2.6,32.491a7.684,7.684,0,0,1,3.471-.168c4.849.646,8.746,3.853,11.66,7.732a35.5,35.5,0,0,1,6.2,13.7c1.071,6.073,1.43,8.929,1.43,8.929l8.929.714S258.763,423.513,262.144,413.293Z",
    transform: "translate(-175.087 -324.026)",
    fill: "#0f1d24",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_584",
    "data-name": "Caminho 584",
    d: "M210.318,889.274a34.575,34.575,0,0,0,9.615-2.362,22.711,22.711,0,0,1-2.187-.968c-1.859-1.006-2.709-1.393-2.709-1.393s-5.327-1.527-8.471-4.791A81.07,81.07,0,0,0,210.318,889.274Z",
    transform: "translate(-167.085 -521.731)",
    fill: "#2e4799",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_585",
    "data-name": "Caminho 585",
    d: "M264.9,536.831l2.339,16.8s17.344,12.7,24.312,16.571,7.124,4.028,8.365,3.252c.556-.348,5.03-4.11,9.937-8.653-10.952-2.906-23.286-7.779-32.55-14.467C270.758,545.607,267.01,540.917,264.9,536.831Z",
    transform: "translate(-187.837 -399.733)",
    fill: "#ba8266",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_586",
    "data-name": "Caminho 586",
    d: "M485.38,647.06c-3.75-20.833-11.535-39.818-13.691-45.112.221,3.328-3.326,11.087-3.326,11.087s-9.6,87.037-7.744,107.79c.53,5.926,1.972,15.848,3.758,26.994,13.265,9.735,28.095,19.152,35.321,18.715,14.766-.895,37.586-6.265,44.3-20.583s40.553-96.385,33.782-102.583-36.9-7.19-39.377-6.49-27.52,67.01-33.785,58.509S489.127,667.89,485.38,647.06Z",
    transform: "translate(-257.38 -422.898)",
    fill: "#7d84a8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_587",
    "data-name": "Caminho 587",
    d: "M588.106,617.242s-.222-26.625.672-31.323,4.7-5.818,5.816-2.014-1.339,16.331,3.8,11.633,10.07-32.887,14.32-38.93,6.937-2.908,6.042,3.133-5.819,22.6-5.819,22.6a8.677,8.677,0,0,1,4.028,6.265c.448,4.249,4.476.671,5.817,5.818s3.579,4.92,3.356,10.961-3.356,19.689-6.487,21.7-8.278,9.843-8.278,9.843-24.386-3.8-25.508-5.815S588.106,617.242,588.106,617.242Z",
    transform: "translate(-301.942 -405.61)",
    fill: "#d3a48c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_588",
    "data-name": "Caminho 588",
    d: "M511.27,753.54c3.13-14.322,9.067-16.67,9.067-16.67A98.706,98.706,0,0,1,510.3,718.552a110.184,110.184,0,0,0-4.847,17.535c-2.238,13.872.448,33.114.448,33.114S508.138,767.859,511.27,753.54Z",
    transform: "translate(-273.098 -464.381)",
    fill: "#8e95b2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_589",
    "data-name": "Caminho 589",
    d: "M608.824,673.4s-24.386-3.8-25.508-5.815c-.816-1.471.754-8.194,1.66-11.712a25.485,25.485,0,0,0-4.563.187s-4.147,7.833-.345,14.545c3.527,6.221,25.887,11.48,37.69,10.615,2.738-9.849,3.853-17,2.032-18.67a8.183,8.183,0,0,0-1.145-.865,5.42,5.42,0,0,1-1.543,1.871C613.97,665.57,608.824,673.4,608.824,673.4Z",
    transform: "translate(-299.389 -442.08)",
    fill: "#8e95b2",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderWithoutServices);
export default __webpack_public_path__ + "static/media/placeholder-without-services.f41795a504e74745c5d2b869e93a6d72.svg";
export { ForwardRef as ReactComponent };